export const cropText = (text = '', maxLength = 20, postfix = '...') => {
    if (!text) {
        return '';
    }

    if (text.length <= maxLength) {
        return text;
    }

    const croppedText = text.substring(0, maxLength - postfix.length);
    return `${croppedText}${postfix}`
}
